export default "__VITE_ASSET__DlF_MSR3__"